import parser from "html-react-parser";
import { useSelector } from "react-redux";
import Modal from "../../utils/customModal";
import { useTranslation } from "react-i18next";
import FacilitiesComponent from "./facilities";
import React, { useState, useEffect } from "react";
import Tooltip from "canvas-core-react/lib/Tooltip";
import Selector from "canvas-core-react/lib/Selector";
import CustomSelect from "../custom-components/select";
import RadioButton from "canvas-core-react/lib/RadioButton";
import { sucessInfoModal, subString } from "../../utils/functions";
import { getFacilities } from "../../../Redux/reducer/credit-line";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import informationPNG from "../../../../static/images/information.png";
import CustomInput from "../custom-components/customInput";
import useForm from "../../hooks/useForm";

const CompanyForm = (props) => {
  const {
    company,
    countryCode,
    accounts,
    save,
    method,
    goBack,
    editCompany = false,
    enableEdit = true,
  } = props;

  const { t } = useTranslation();
  const baseFacilities =
    editCompany === true ? company?.company?.facilityResponse || [] : [];
  const facilities = useSelector((state) => getFacilities(state));
  const [selectedFacilities, setSelectedFacilities] = useState(baseFacilities);
  const [selectedAccounts, setSelectedAccounts] = useState({});
  const [feci, setFeci] = useState(
    company.company !== undefined ? company.company.exemptFeci : false
  );
  const [companyState, setCompanyState] = useState(
    company.company !== undefined ? company.company.status : ""
  );

  const [modal, setModal] = useState({
    show: false,
    modalContent: null,
    onClose: undefined,
    showOnClose: false,
  });

  useEffect(() => {
    if (props.enableEdit === true) {
      var baseAccounts = {};
      if (company.company !== undefined) {
        company.company.facilityResponse.map((facility) => {
          baseAccounts[`selector-${facility.lineOfCreditNumber}`] =
            accounts.find(
              (accnt) => facility.accountNumber == accnt.iban_account_number
            );
        });
      }

      setSelectedAccounts(baseAccounts);
    }
  }, [props.enableEdit]);

  const showAvailablesFacilities = () => {
    setModal({
      show: true,
      modalContent: (
        <FacilitiesComponent
          facilities={facilities}
          selectedFacilities={selectedFacilities}
          handleFacilities={handleFacilities}
          closeModal={closeModal}
        />
      ),
      onClose: closeModal,
      showOnClose: true,
    });
  };

  const closeModal = () => {
    setModal({
      show: false,
      modalContent: null,
      onClose: undefined,
      showOnClose: false,
    });
  };

  const handleFacilities = (newFacilities, reverseCreditLines, currencies) => {
    const currentAccounts = { ...selectedAccounts };
    currencies.forEach((currency) => {
      newFacilities
        .filter((facility) => facility.currencyCode === currency)
        .forEach((facility) => {
          const currentReverseFacility = baseFacilities.find(
            (reverseFacility) =>
              reverseFacility.lineOfCreditNumber ===
              reverseCreditLines[currency]
          );

          const account = accounts.find(
            (accnt) =>
              currentReverseFacility?.accountNumber ===
              accnt.iban_account_number
          );

          facility.accountNumber = account?.iban_account_number;
          currentAccounts[`selector-${facility.lineOfCreditNumber}`] = account;
        });
    });

    facilities.forEach((facility) => {
      const creditLine = facility.lineOfCreditNumber;
      const facilityFound = newFacilities.find(
        (newFacility) => newFacility.lineOfCreditNumber === creditLine
      );

      if (!facilityFound) {
        delete currentAccounts[`selector-${creditLine}`];
      }
    });

    setSelectedFacilities(newFacilities);
    setSelectedAccounts(currentAccounts);
    infoModal();
  };

  const infoModal = () => {
    const message = parser(
      `Su línea de crédito ha sido agregada con éxito.<br /><span class="flex-element" style="margin-top: 5px"><img src="${informationPNG}" style="margin-right: 5px" />Recuerde seleccionar una cuenta.</span>`
    );
    const buttons = { formBtn: { text: "Aceptar", action: closeModal } };
    setModal({
      show: true,
      modalContent: sucessInfoModal(
        t("clients.profile.company.facilities.modal.title"),
        message,
        buttons
      ),
      onClose: closeModal,
      showOnClose: false,
    });
  };

  const onChangeAccount = (e) => {
    const newSelectedAccounts = { ...selectedAccounts };
    const account = accounts.find(
      (accnt) => e.target.value == accnt.iban_account_number
    );

    const creditLine = e.target.name.split("-").pop();
    const facility = selectedFacilities.find(
      (facility) => facility.lineOfCreditNumber === creditLine
    );

    const overdraftLine = selectedFacilities
      .filter(
        (currentFacility) =>
          currentFacility.currencyCode === facility.currencyCode
      )
      .find((facility) => facility.isOverdraftLine);

    newSelectedAccounts[e.target.name] = account;

    /* istanbul ignore else */
    if (overdraftLine) {
      selectedFacilities.find(
        (facility) =>
          facility.lineOfCreditNumber === overdraftLine.lineOfCreditNumber
      ).accountNumber = account.iban_account_number;

      newSelectedAccounts[`selector-${overdraftLine.lineOfCreditNumber}`] =
        account;
    }

    setSelectedFacilities(selectedFacilities);
    setSelectedAccounts(newSelectedAccounts);
  };

  const getClient = () => {
    let data = {};
    const creditLines = [];

    selectedFacilities.forEach((facility) => {
      creditLines.push({
        accountCurrency:
          selectedAccounts[`selector-${facility.lineOfCreditNumber}`]?.currency,
        accountNumber:
          selectedAccounts[`selector-${facility.lineOfCreditNumber}`]
            ?.iban_account_number,
        subFacilityNumber: facility.lineOfCreditNumber,
        isOverdraftLine: facility.isOverdraftLine,
        interestRate: facility.interestRate,
        baseRate: facility.baseRate,
        approvedAmount: facility.approvedAmount,
        isReverseLine: facility.isReverseLine,
      });
    });

    switch (method) {
      case "CREATE":
        data = {
          businessId: company?.identification,
          businessIdType: company?.identificationType,
          cif: company?.cif,
          name: company?.name,
          countryId: company?.address?.country?.id,
          notificationEmail: company?.email,
          phone: company?.phone,
          company: {
            creditLines,
            codeDestinationFound: values.codeDestinationFound,

            ...(countryCode === "PA" && { codeCinu: values.codeCinu }),
          },
        };
        break;
      case "UPDATE":
        data = {
          creditLines,
          status: companyState === company.company.status ? null : companyState,
          codeDestinationFound: values.codeDestinationFound,
          ...(countryCode === "PA" && { codeCinu: values.codeCinu }),
        };
        break;
    }

    /* istanbul ignore else */
    if (countryCode === "PA") data = { ...data, exemptFeci: feci };

    return data;
  };

  const saveCompany = () => {
    if (Object.keys(selectedAccounts).length == selectedFacilities.length) {
      let data = getClient();
      save(data);
    } else {
      const buttons = {
        formBtn: { text: t("general.buttons.accept"), action: closeModal },
      };

      setModal({
        show: true,
        modalContent: sucessInfoModal(
          t("clients.profile.company.facilities.modal.errorTitle"),
          t("clients.profile.company.facilities.modal.errorMsg"),
          buttons
        ),
        onClose: closeModal,
        showOnClose: false,
      });
    }
  };

  const { values, errors, handleChange, onSubmit } = useForm({
    callback: saveCompany,
    initialState: {
      codeCinu: company?.company?.codeCinu || "",
      codeDestinationFound: company?.company?.codeDestinationFound || "",
    },
    validation: {
      codeDestinationFound: { required: true },
      ...(countryCode === "PA" && { codeCinu: { required: true } }),
    },
  });

  return (
    <div id="client-detailed-profile-add">
      <div className="flex-element">
        <div className="column">
          <div className="column-row">
            <div className="input small">
              <label htmlFor="companyName">
                {t("clients.profile.company.form.name")}
              </label>
              <input
                type="text"
                id="companyName"
                name="companyName"
                value={subString(company.name, 43)}
                readOnly
              />
            </div>
            <div className="input small">
              <label htmlFor="companyCif">
                {t("clients.profile.company.form.cif")}
              </label>
              <input
                type="text"
                id="companyCif"
                name="companyCif"
                value={company.cif}
                readOnly
              />
            </div>
          </div>
        </div>
        <div className="column">
          <div className="column-row">
            <div className="input small">
              <label htmlFor="companyId">
                {t("clients.profile.company.form.id")}
              </label>
              <input
                type="text"
                id="companyId"
                name="companyId"
                value={company.identification || company.businessId}
                readOnly
              />
            </div>
            <div className="input small">
              <label htmlFor="companyState">
                {t("clients.profile.company.form.state")}
              </label>
              {enableEdit && editCompany ? (
                <>
                  <CustomSelect
                    id="companyState"
                    className={`input input--text input-w-aux__input input--active as new-input-client ${
                      company.recordTmps[0] !== null &&
                      company.recordTmps[0].data !== null &&
                      company.recordTmps[0].data?.status
                        ? "edited-info"
                        : ""
                    }`}
                    items={[
                      {
                        value: "ACTIVE",
                        name: `${t("general.states.ACTIVE")}`,
                      },
                      {
                        value: "INACTIVE",
                        name: `${t("general.states.INACTIVE")}`,
                      },
                      {
                        value: "DELETED",
                        name: `${t("general.states.DELETED")}`,
                      },
                    ]}
                    name="companyState"
                    value={`${t(`general.states.${company.company.status}`)}`}
                    valueAttr={"value"}
                    handleChange={(event) =>
                      setCompanyState(event.target.value)
                    }
                  />
                  {company.recordTmps[0] !== null &&
                    company.recordTmps[0].data !== null &&
                    company.recordTmps[0].data.status && (
                      <div className="flex-element">
                        <label
                          className="edited-client-info"
                          htmlFor="companyName"
                        >
                          {t("general.labels.pendindForApproval")}
                        </label>
                        <div className="left-flex fix-tooltip">
                          <Tooltip
                            id="tooltip-id"
                            closeButtonLabel="Close Tooltip"
                            infoButtonLabel="Info"
                            position={"left"}
                            heading={t("general.labels.pendindHeader")}
                          >
                            <label
                              className="edited-client-info tooltip-color"
                              htmlFor="companyName"
                            >
                              {`${t(
                                "clients.profile.company.form.pendindState"
                              )} ${
                                company.recordTmps[0].data.status === "INACTIVE"
                                  ? t("general.states.INACTIVE").toLowerCase()
                                  : t("general.states.ACTIVE").toLowerCase()
                              }.`}
                            </label>
                          </Tooltip>
                        </div>
                      </div>
                    )}
                </>
              ) : (
                <input
                  type="text"
                  id="companyState"
                  name="companyState"
                  value={
                    editCompany === true
                      ? t(`general.states.${company?.company?.status}`)
                      : t(`general.states.ACTIVE`)
                  }
                  readOnly
                />
              )}
            </div>
          </div>
        </div>
      </div>
      {selectedFacilities.map((facility, idx) => (
        <div key={`facility-${idx}`} className="card-element">
          <h2>
            {`${
              facility.isReverseLine
                ? t(
                    `clients.profile.company.facilities.table.${facility.currencyCode.toLowerCase()}ReverseSubfacility`
                  )
                : t(
                    `clients.profile.company.facilities.table.${facility.currencyCode.toLowerCase()}OverdraftSubfacility`
                  )
            }`}
          </h2>
          <div className="flex-element">
            <div className="column">
              <div className="column-row">
                <div className="input small">
                  <label htmlFor="subFacility">
                    {t("clients.profile.company.facilities.number")}
                  </label>
                  <input
                    type="text"
                    id="subFacility"
                    name="subFacility"
                    value={
                      facility.lineOfCreditNumber !== undefined
                        ? facility.lineOfCreditNumber
                        : ""
                    }
                    readOnly
                  />
                </div>
                <div className="input small">
                  <label htmlFor="subFacilityBaseRate">
                    {t("clients.profile.company.facilities.base")}
                  </label>
                  <input
                    type="text"
                    id="subFacilityBaseRate"
                    name="subFacilityBaseRate"
                    value={
                      facility.baseRate !== undefined ? facility.baseRate : ""
                    }
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div className="column">
              <div className="column-row">
                <div className="input small">
                  <label htmlFor="spreadSubFacility">
                    {t("clients.profile.company.facilities.spread")}
                  </label>
                  <input
                    type="text"
                    id="spreadSubFacility"
                    name="spreadSubFacility"
                    value={`${
                      facility.spread !== undefined ? facility.interestRate : ""
                    } %`}
                    readOnly
                  />
                </div>
                <div className="input small">
                  <label htmlFor="subFacilityBaseRate">
                    {t("clients.profile.company.facilities.mount")}
                  </label>
                  <input
                    type="text"
                    id="subFacilityBaseRate"
                    name="subFacilityBaseRate"
                    value={`${
                      facility.currencyDetail !== undefined &&
                      facility.currencyDetail.currencySymbol !== undefined
                        ? facility.currencyDetail.currencySymbol
                        : ""
                    } ${
                      facility.totalUsedAmount !== undefined
                        ? facility.totalUsedAmount
                        : ""
                    }`}
                    readOnly
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex-element">
            <div className="column">
              <div className="column-row">
                <div className="input small">
                  <label htmlFor="subFacility">
                    {t("clients.profile.company.facilities.lcmount")}
                  </label>
                  <input
                    type="text"
                    id="amountLC"
                    name="amountLC"
                    value={`${
                      facility.currencyDetail !== undefined &&
                      facility.currencyDetail.currencySymbol !== undefined
                        ? facility.currencyDetail.currencySymbol
                        : ""
                    } ${
                      facility.approvedAmount !== undefined
                        ? facility.approvedAmount
                        : ""
                    }`}
                    readOnly
                  />
                </div>
                <div className="input small">
                  <label htmlFor="subFacilityBaseRate">
                    {t("clients.profile.company.facilities.state")}
                  </label>
                  <input
                    type="text"
                    id="subFacilityBaseRate"
                    name="subFacilityBaseRate"
                    value={
                      facility.statusDescription !== undefined
                        ? t(
                            `general.states.${
                              status[facility.statusDescription.toLowerCase()]
                            }`
                          )
                        : ""
                    }
                    readOnly
                  />
                </div>
              </div>
            </div>
            <div className="column" id="gg">
              <div className="column-row">
                <div className="input full">
                  <label htmlFor="account">
                    {t("clients.profile.company.facilities.account")}
                  </label>
                  {editCompany && !enableEdit && (
                    <input
                      type="text"
                      id="accountNumber"
                      name="accountNumber"
                      value={facility.accountNumber}
                      readOnly
                    />
                  )}
                  {enableEdit && facility.isReverseLine && (
                    <Selector
                      className="account-selector no-label"
                      onChange={onChangeAccount}
                      id={`selector-${idx}`}
                      name={`selector-${facility.lineOfCreditNumber}`}
                      label=""
                      placeholder={t(
                        "clients.profile.company.facilities.account"
                      )}
                      error={
                        selectedAccounts[
                          `selector-${facility.lineOfCreditNumber}`
                        ] !== undefined
                          ? null
                          : {
                              label: t(
                                "clients.profile.company.facilities.errorTitleAccount"
                              ),
                              messages: [
                                t(
                                  "clients.profile.company.facilities.errorMessageAccount"
                                ),
                              ],
                            }
                      }
                      value={
                        selectedAccounts[
                          `selector-${facility.lineOfCreditNumber}`
                        ] !== undefined
                          ? selectedAccounts[
                              `selector-${facility.lineOfCreditNumber}`
                            ].iban_account_number
                          : ""
                      }
                    >
                      {accounts
                        .filter(
                          (account) =>
                            account.currency === facility.currencyCode
                        )
                        .map((account, indx) => (
                          <option
                            key={`option-${idx}-${indx}`}
                            value={account.iban_account_number}
                          >
                            {account.iban_account_number}
                          </option>
                        ))}
                    </Selector>
                  )}
                  {enableEdit && facility.isOverdraftLine && (
                    <span className="overdraft-account-number">
                      {facility.accountNumber}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      <div className="flex-element">
        {countryCode === "PA" && (
          <div className="column">
            <div className="column-row ">
              <div className="input small">
                <label htmlFor="feci">
                  {t("clients.profile.company.facilities.feci")}
                </label>
                <div className="flex-element radio-group">
                  <RadioButton
                    label={t("general.labels.yes")}
                    id="EximptFeci"
                    name="feci"
                    checked={feci === true}
                    onChange={() => setFeci(true)}
                    disabled={!enableEdit}
                  />
                  <RadioButton
                    label={t("general.labels.no")}
                    id="NotEximptFeci"
                    name="feci"
                    checked={feci === false ? true : false}
                    onChange={() => setFeci(false)}
                    disabled={!enableEdit}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        <div className="column">
          <div className="column-row">
            {countryCode === "PA" && (
              <CustomInput
                className="input small"
                inputClass="input-code-fix-padding"
                label={t("clients.profile.company.form.cinu")}
                name="codeCinu"
                onChange={handleChange}
                value={values.codeCinu}
                error={errors.codeCinu}
                readOnly={!enableEdit}
              />
            )}

            <CustomInput
              className="input small"
              inputClass="input-code-fix-padding"
              label={t("clients.profile.company.form.fundDestinationCod")}
              name="codeDestinationFound"
              value={values.codeDestinationFound}
              onChange={handleChange}
              error={errors.codeDestinationFound}
              readOnly={!enableEdit}
            />
          </div>
        </div>
      </div>

      <div className="form-actions clearfix">
        {goBack !== undefined && (
          <SecondaryButton
            id={`back-btn`}
            className="btnLimpiar"
            onClick={goBack}
          >
            {t("general.buttons.back")}
          </SecondaryButton>
        )}
        {enableEdit === true && (
          <>
            <SecondaryButton
              id={`facilities-btn`}
              className="btnFacility"
              onClick={showAvailablesFacilities}
            >
              {selectedFacilities.length > 0
                ? t("general.buttons.editFacilities")
                : t("general.buttons.addFacilities")}
            </SecondaryButton>
            {selectedFacilities.length > 0 && (
              <SecondaryButton
                id={`process-btn`}
                className="btnAgregar"
                onClick={onSubmit}
              >
                {t("general.buttons.sendForApproval")}
              </SecondaryButton>
            )}
          </>
        )}
      </div>
      <Modal
        show={modal.show}
        handleClose={modal.onClose}
        showClose={modal.showOnClose}
      >
        {modal.modalContent}
      </Modal>
    </div>
  );
};

export default CompanyForm;

const status = {
  activa: "ACTIVE",
  inactiva: "INACTIVE",
  eliminado: "DELETED",
};
